import { type WorkspaceMedia } from '@backend/lib/db/typeRoots/workspaceMedia'
import {
  WorkspaceMediaManager,
  type GeneratingImage,
} from '../workspace-media/workspace-media-manager'
import { WorkspaceCaption } from '../workspace-caption'
import { type PlatformType } from '@backend/lib/db/schema/platform'
import type { AiLabelStyle } from '@backend/lib/platforms/aiDisclosure'

interface Props {
  workspaceMedia: WorkspaceMedia[]
  setMedia: (media: WorkspaceMedia[], updateDb: boolean) => Promise<void>
  workspaceId: number
  fileInputRef: React.RefObject<HTMLInputElement | null>
  textareaRef: React.RefObject<HTMLTextAreaElement | null>
  caption: string
  onCaptionChange: (value: string) => void
  isSaving: boolean
  selectedCaptionPlatform: PlatformType
  title?: string
  onTitleChange?: (value: string) => void
  onEdit: (media: WorkspaceMedia, index: number) => void
  onAddMedia: () => void
  onAutoDesign?: (media: WorkspaceMedia, index: number) => void
  generatingImages?: GeneratingImage[]
  /** The selected platform's caption was already published — no more edits. */
  captionReadOnly?: boolean
  /** Draw the AI label over image media in the workspace. Opt-in. */
  showAiLabel?: boolean
  aiLabelStyle?: AiLabelStyle
}

export function WorkspaceLayoutPost({
  workspaceMedia,
  setMedia,
  workspaceId,
  fileInputRef,
  textareaRef,
  caption,
  onCaptionChange,
  isSaving,
  selectedCaptionPlatform,
  title,
  onTitleChange,
  onEdit,
  onAddMedia,
  onAutoDesign,
  generatingImages,
  captionReadOnly,
  showAiLabel,
  aiLabelStyle,
}: Props) {
  return (
    <div className="border-border flex w-full flex-col gap-2 rounded-lg border p-2">
      {/* Caption Section */}
      <WorkspaceCaption
        textareaRef={textareaRef}
        caption={caption}
        onCaptionChange={onCaptionChange}
        isSaving={isSaving}
        selectedCaptionPlatform={selectedCaptionPlatform}
        title={title}
        onTitleChange={onTitleChange}
        readOnly={captionReadOnly}
      />

      {/* Media Grid Section */}
      <div className="w-full">
        <WorkspaceMediaManager
          media={workspaceMedia}
          setMedia={setMedia}
          workspaceId={workspaceId}
          fileInputRef={fileInputRef}
          onEdit={onEdit}
          onAddMedia={onAddMedia}
          onAutoDesign={onAutoDesign}
          generatingImages={generatingImages}
          showAiLabel={showAiLabel}
          aiLabelStyle={aiLabelStyle}
        />
      </div>
    </div>
  )
}
